<nb-card>
  <nb-card-header [nbSpinner]="loading" nbSpinnerStatus="info">
    <div class="row">
      <div class="col-12 form-inline">
        <nb-form-field fullWidth>
          <nb-icon nbPrefix icon="search-outline"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            placeholder="{{ 'common.strSearch' | translate }}"
            [(ngModel)]="product.title"
            (keydown.enter)="inputPrice()"
            #title
          />
        </nb-form-field>

        <h6 *ngIf="isMoreInfo" class="text-primary">
          {{ product.price | number }}
        </h6>

        <button
          nbButton
          outline
          shape="round"
          status="info"
          size="small"
          (click)="inputMore()"
        >
          <nb-icon
            [icon]="
              isMoreInfo
                ? 'arrow-ios-upward-outline'
                : 'arrow-ios-downward-outline'
            "
          ></nb-icon>
        </button>

        <button
          *ngIf="!isMoreInfo"
          nbButton
          outline
          shape="semi-round"
          status="primary"
          size="small"
          (click)="onNew()"
          [disabled]="loading"
          [class.btn-pulse]="loading"
        >
          <span>{{ "buttons.create" | translate }}</span>
        </button>

        <button
          *ngIf="!isMoreInfo"
          nbButton
          outline
          shape="semi-round"
          status="success"
          size="small"
          (click)="printProducts()"
          [disabled]="loading"
          [class.btn-pulse]="loading"
        >
          <nb-icon icon="printer-outline"></nb-icon>
          <span>{{ "buttons.printProducts" | translate }}</span>
        </button>

        <button
          *ngIf="isMoreInfo"
          nbButton
          hero
          status="info"
          size="small"
          (click)="create()"
          [disabled]="submitted || !product.title || product.title.length === 0"
          [class.btn-pulse]="submitted"
        >
          <nb-icon nbPrefix icon="save-outline"></nb-icon>
          {{ "buttons.save" | translate }}
        </button>
      </div>
    </div>

    <div *ngIf="isMoreInfo" class="row">
      <div class="col-12 form-inline">
        <nb-form-field>
          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="{{ 'product.price' | translate }}"
            [(ngModel)]="product.price"
            (keydown.enter)="create()"
            #price
            [ngxNumberFormat]="formatCurrency"
          />
        </nb-form-field>

        <nb-form-field fullWidth>
          <button
            nbPrefix
            nbButton
            ghost
            size="small"
            status="danger"
            (click)="removeCatalog('units')"
          >
            <nb-icon icon="close-outline"></nb-icon>
          </button>
          <nb-select
            class="type-select"
            size="small"
            fullWidth
            [(ngModel)]="product.unitId"
            placeholder="{{ 'product.unit' | translate }}"
          >
            <nb-option *ngFor="let opt of units" [value]="opt.id">{{
              opt.title
            }}</nb-option>
          </nb-select>
        </nb-form-field>

        <nb-form-field fullWidth>
          <button
            nbPrefix
            nbButton
            ghost
            size="small"
            status="danger"
            (click)="removeCatalog('groups')"
          >
            <nb-icon icon="close-outline"></nb-icon>
          </button>
          <nb-select
            class="type-select"
            size="small"
            fullWidth
            placeholder="{{ 'common.groups' | translate }}"
            [(ngModel)]="product.groupId"
          >
            <nb-option *ngFor="let opt of groups" [value]="opt.id">{{
              opt.title
            }}</nb-option>
          </nb-select>
        </nb-form-field>

        <nb-form-field fullWidth>
          <button
            nbPrefix
            nbButton
            ghost
            size="small"
            status="danger"
            (click)="removeCatalog('categories')"
          >
            <nb-icon icon="close-outline"></nb-icon>
          </button>
          <nb-select
            class="type-select"
            size="small"
            fullWidth
            placeholder="{{ 'common.categories' | translate }}"
            [(ngModel)]="product.categoryId"
          >
            <nb-option *ngFor="let opt of categories" [value]="opt.id">{{
              opt.title
            }}</nb-option>
          </nb-select>
        </nb-form-field>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="row">
      <div
        *ngFor="let item of products | filter: product.title; let i = index"
        class="col-md-12"
      >
        <ngx-view-product
          [shop]="shop"
          [shopId]="shopId"
          [units]="units"
          [groups]="groups"
          [categories]="categories"
          [suppliers]="suppliers"
          [producers]="producers"
          [origins]="origins"
          [sizes]="sizes"
          [colors]="colors"
          [product]="item"
          [mode]="mode"
          (onDelete)="onDelete($event)"
          (onEdit)="onEdit($event)"
        ></ngx-view-product>
      </div>

      <div class="col-md-12" *ngIf="loading">
        <ngx-view-placeholder></ngx-view-placeholder>
      </div>
    </div>
  </nb-card-body>
</nb-card>
